import React from "react";
import Footer from "../../components/general components/Footer";
import Header from "../../components/general components/Header";
import * as C from "./styles";
import { BsGearFill } from "react-icons/bs";

const Certifications = () => {
  return (
    <C.Container>
      <Header />

      <h1>Certificações</h1>
      <BsGearFill />
      <C.Certifications></C.Certifications>
      <Footer />
    </C.Container>
  );
};

export default Certifications;
